export class PositionListDTO {

    id: string;

    name: string;

    description: string;

}
